'use client'

import { useSelector } from '@/hooks/redux'
import { usePathname } from '@/navigation'
import { setPath } from '@/reducers/workflow'
import {
  commonFlowSteps,
  Formalities,
  ModuleType,
  paymentSteps
} from '@/workflows/modules'
import { Steps } from 'antd'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

interface BreadcrumbProps {}

const Breadcrumb: React.FC<BreadcrumbProps> = () => {
  const dispatch = useDispatch()
  const t = useTranslations()
  const pathname = usePathname()
  const workflow = useSelector((state) => state.workflow)
  const societyInformations = useSelector((state) => state.societyInformations)

  const flow = workflow.flow
  const flowType = workflow.flowType
  const isMicro = societyInformations.isMicro
  const availableFormality = societyInformations.formality
  const hideDomideal = sessionStorage.getItem('hideDomideal') === '1'

  const [flowSteps, setFlowSteps] = useState<ModuleType[]>([])
  const [currentStep, setCurrentStep] = useState(
    flowSteps.findIndex((item: ModuleType) => item.path === pathname)
  )

  const breadcrumbBuilder = () => {
    const steps = [...commonFlowSteps]
    if (availableFormality && !hideDomideal) steps.push(Formalities)
    steps.push(...paymentSteps)

    return steps
  }

  useEffect(() => {
    if (flowType === 'create_or_transfert') return
    if (workflow.path === '/welcome' || workflow.path === '/payment/processing')
      return setFlowSteps([])
    return setFlowSteps(breadcrumbBuilder())
  }, [flowType, isMicro, availableFormality, hideDomideal])

  useEffect(() => {
    setCurrentStep(
      flowSteps.findIndex((item: ModuleType) => item.path === pathname)
    )
  }, [pathname, flowSteps])

  const onChange = (value: number) => {
    const newPath = flowSteps[value].path
    if (flow.includes(newPath)) dispatch(setPath(newPath))
  }

  const getStatus = (index: number) => {
    if (index === currentStep) {
      return 'process'
    } else if (flow.includes(flowSteps[index].path)) {
      return 'finish'
    } else {
      return 'wait'
    }
  }
  useEffect(() => {
    const processStep = document.querySelector('.ant-steps-item-process')
    const finishSteps = document.querySelectorAll('.ant-steps-item-finish')

    if (processStep) {
      processStep
        .querySelector('.ant-steps-item-title')!
        .classList.add('!text-interaction', 'font-semibold')
      finishSteps.forEach((item) =>
        item
          .querySelector('.ant-steps-item-title')
          ?.classList.remove('!text-interaction', 'font-semibold')
      )
      return
    }
    return
  }, [currentStep])

  return (
    <Steps
      data-testid='subflow-breadcrumb'
      progressDot
      className='h-fit w-max [&_.ant-steps-item-active]:!text-interaction'
      direction='vertical'
      onChange={onChange}
      current={currentStep}
      items={flowSteps.map((item, index) => ({
        title: t(`breadcrumb.${item.name}`),
        status: getStatus(index),
        disabled: !flow.includes(item.path)
      }))}
    />
  )
}

export default Breadcrumb
